<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            endpoint: String,
        },
        data() {
            return {
                ready: false,
                items: null,
            }
        },
        methods: {
            hasCursusTag(news) {
                return !!news.tags?.some(tag => tag.name === 'cursus');
            },
            async init() {
                const { data } = await axios.get(this.endpoint);
                this.items = data;
                this.ready = true;
            },
        },
        created() {
            this.init();
        }
    }
</script>
